.bu{right:0px;}